<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "ImgAi",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'imgAi:add',
        update: 'imgAi:update',
        delete: 'imgAi:delete',
        deleteBatch: 'imgAi:deleteBatch'
      },
      url: {
        get: '/imgAi/listByCondition',
        add: '/imgAi/add',
        update: '/imgAi/update',
        delete: '/imgAi/delete/',
        delete_batch: '/imgAi/deleteBatch',
        status: '/imgAi/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      },{
        field: 'style',
        label: '风格',
        show: true,
        width: '',
      },  {
        field: 'prompt',
        label: '描述',
        show: true,
        width: '',
      }, {
        field: 'size',
        label: '图片尺寸(分辨率)',
        show: true,
        width: '',
      }, {
        field: 'imgUrl',
        label: '生成图像路径',
        detail: true,
        img: true,
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '图像Ai',
        updateTitle: '图像Ai',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'userId',
          label: '用户ID',
          type: 'input',
          placeholder: '用户ID',
          rules: [{message: '请输入用户ID', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'prompt',
          label: '描述',
          type: 'editor',
          placeholder: '描述',
          rules: [{message: '请输入描述', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },  {
          field: 'style',
          label: '风格',
          type: 'input',
          placeholder: '风格',
          rules: [{message: '请输入风格', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'size',
          label: '图片尺寸(分辨率)',
          type: 'input',
          placeholder: '图片尺寸',
          rules: [{message: '请输入图片尺寸', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'imgUrl',
          label: '图像路径',
          type: 'input',
          placeholder: '图像路径',
          rules: [{message: '请输入图像路径', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
